module.exports = __webpack_public_path__ + "static/media/type.55564dde.wav";